import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExamsService } from '../exams.service';

// DICOM inbox: lists unassociated studies (no accession, or accession matching no
// exam in this clinic) from the clinic's GCP store so a clinician can verify each
// in the Artisan DICOM Viewer and link the right one to the current exam.
// Replaces the legacy inbox in the exam header for DICOM-configured clinics.
@Component({
    selector: 'app-dicom-inbox',
    templateUrl: './dicom-inbox.component.html',
    styleUrls: ['./dicom-inbox.component.scss'],
    standalone: false
})
export class DicomInboxComponent implements OnInit {
  @Output() closed = new EventEmitter<null>();

  start: Date;
  startb: Date;
  From: Date;
  To: Date;

  loading = false;
  clinicId: string | null = null;
  studies: {
    studyUID: string; studyDate: string | null; accessionNumber: string | null;
    modality: string | null; patientName: string | null; patientId: string | null;
    numInstances: number | null;
  }[] = [];
  linkedUID: string | null = null; // set after a successful link in this session

  constructor(private http: HttpClient, public es: ExamsService) { }

  ngOnInit() {
    this.start = new Date(this.es.CreationTime);
    this.To = this.start;
    this.startb = new Date(this.start.getTime() - (24 * 60 * 60 * 1000) * 7);
    this.From = this.startb;
    this.getList();
  }

  private ymd(d: Date): string {
    const m = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${d.getFullYear()}${m}${day}`;
  }

  getList() {
    this.loading = true;
    this.http.get<{ configured: boolean; clinicId?: string; studies: any[] }>(
      '/api/dicom/unassociated',
      { params: { from: this.ymd(new Date(this.From)), to: this.ymd(new Date(this.To)) } }
    ).subscribe({
      next: (data) => {
        this.clinicId = data?.clinicId ?? null;
        // QIDO doesn't guarantee ordering — sort to match the From→Until range direction
        this.studies = (data?.studies ?? []).sort((a, b) =>
          (a.studyDate || '').localeCompare(b.studyDate || '')
        );
        this.loading = false;
      },
      error: () => { this.studies = []; this.loading = false; },
    });
  }

  view(studyUID: string) {
    if (!this.clinicId) return;
    window.open(`https://viewer.beta.artisansonics.com/study/${studyUID}?clinicId=${encodeURIComponent(this.clinicId)}`, '_blank');
  }

  link(studyUID: string) {
    this.linkedUID = studyUID;
    this.es.linkDicomStudy(studyUID, () => this.getList());
  }
}
